import { Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useState, useMemo, useRef } from "react";
import InnerForm from "./InnerForm";
import {
  businessBoxv2InitialValues,
  businessBoxv2ValidationSchema,
} from "./BusinessBoxHelpers";
import {
  useCreateBusinessBoxV2,
  useUpdateBusinessBoxV2,
  useUpdatePrimaryBusinessBox,
} from "../../../../services/mutations";
import { toast } from "react-toastify";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import DataBox from "../../BusinessBox/DataBox";
import { socialPlatforms } from "../../../NewBusinessBox/BusinessBoxHelpers";
import Placeholder from "@assets/images/Image-Placeholder-Dark.png";
import SaveChangesModal from "../../../SaveChangesModal";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileBusinessBox } from "../../../../redux/reducers/gallery";
import { isEmpty } from "lodash";
import { InfoOutlined } from "@material-ui/icons";
import { SocialIcons } from "../../../../utils/socialHelpers";
import { getWheelBusinessBox } from "../../../../redux/selectors/segmentBuilderSelectors";
import {
  pushToHistoryAction,
  setBusinessBoxWheel,
} from "../../../../redux/reducers/segmentBuilder";
import { editUserProfileAction } from "../../../../redux/actions";
import {
  closeDialogPopup,
  openDialogPopup,
} from "../../../../redux/reducers/dialogPopup";
import ProSuite from "@assets/images/ProSuite.svg";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import BusinessBoxPermissionDialog from "./additionalModals/BusinessBoxPermissionDialog";
import { is } from "date-fns/locale";
import { openUpgradePopup } from "../../../../redux/reducers/upgradePopup";

//todo : cleanup openDefault logic since it's redundant
const BusinessBoxForm = ({
  initialValues,
  svChOpen,
  svChOpenSetter,
  onClose,
  pendingChangesSetter,
  pendingChanges,
  openDefault = true,
  hideTabs,
  isWheelBusinessBox = false,
  openLibrarySection = false, // Add this prop
  currentPlan = null,
  currentPlanLoading,
}) => {
  const [apiLoading, setApiLoading] = useState(false);
  const [applyScope, setApplyScope] = useState("gallery"); // "gallery" or "account"
  const [showPermissionDialog, setShowPermissionDialog] = useState(false);
  const [pendingFormValues, setPendingFormValues] = useState(null);
  const [pendingFormikHelpers, setPendingFormikHelpers] = useState(null);
  const pendingFormValuesRef = useRef(null);
  const [dialogOptions, setDialogOptions] = useState([
    { value: "gallery", label: "Gallery only" },
    { value: "account", label: "Account-wide" },
  ]);
  const [showBBPremiumDialogAlways, setShowBBPremiumDialogAlways] =
    useState(false);

  const dispatch = useDispatch();

  const currBbox = useSelector((state) => {
    if (isWheelBusinessBox) {
      return getWheelBusinessBox(state);
    } else if (!isEmpty(state.gallery.profile?.business_box) && openDefault) {
      return state.gallery?.profile?.business_box;
    }
    return null;
  });

  const [selectedBBox, setSelectedBBox] = useState();

  console.log("selectedBBox", selectedBBox);
  useEffect(() => {
    if (openDefault) {
      setSelectedBBox({ ...currBbox, isEditMode: true });
    }
  }, [openDefault, currBbox]);

  const BboxDataBox = ({ selectedBBoxData }) => {
    const { values } = useFormikContext();

    // Deterministically compute the props for DataBox based on the latest state.
    const dataBoxProps = useMemo(
      () => ({
        imageSrc:
          values?.media_url || selectedBBoxData?.media_url || Placeholder,
        business_title:
          values?.business_title ||
          selectedBBoxData?.business_title ||
          "Title here",
        description:
          values?.description ||
          selectedBBoxData?.description ||
          "Description here",
        ctaButtons: values?.business_box_cta,
        icons:
          (values?.business_link?.length > 0 &&
            values.business_link?.map((linkItem, idx) => {
              return {
                id: idx,
                icon: linkItem.icon,
                link: linkItem.link,
                is_cta_enabled: linkItem.is_cta_enabled,
              };
            })) ||
          (selectedBBoxData?.business_link?.length > 0 &&
            selectedBBoxData.business_link?.map((linkItem, idx) => {
              return {
                id: idx,
                icon: linkItem.icon,
                link: linkItem.link,
                is_cta_enabled: linkItem.is_cta_enabled,
              };
            })) ||
          [],
      }),
      [values, selectedBBoxData]
    );

    return <DataBox data={dataBoxProps} isFormPreview={true} />;
  };

  const createBusinessBox = useCreateBusinessBoxV2();
  const updateBusinessBox = useUpdateBusinessBoxV2();
  const setPrimaryBusinessBox = useUpdatePrimaryBusinessBox();

  const FormStateWatcher = () => {
    const { dirty, submitCount, touched } = useFormikContext();

    useEffect(() => {
      if (dirty && submitCount < 1 && !isEmpty(touched)) {
        pendingChangesSetter(true);
      } else {
        pendingChangesSetter(false);
      }
    }, [dirty, submitCount, touched]);
    return null;
  };

  const handleBusinessBoxPermissions = (options = {}) => {
    const { showDialogAlways = false, values = null } = options;

    if (showDialogAlways) {
      setShowBBPremiumDialogAlways(true);
      if (isWheelBusinessBox) {
        setDialogOptions([
          {
            value: "wheel",
            label:
              "This Wheel Only – Saves the Business Box only for this Wheel",
            disabled: currentPlan?.sub_tier === 2,
          },
          {
            value: "gallery",
            label:
              "Gallery – Applies this Business Box to this wheel and the Gallery Page",
            disabled: currentPlan?.sub_tier === 2,
          },
          {
            value: "account",
            label:
              "Account-wide – Replaces the Business Box on the Gallery Page and every existing wheel on your account",
          },
        ]);
        setApplyScope(currentPlan?.sub_tier === 2 ? "account" : "wheel"); // Set default selection for wheel context
      } else {
        setDialogOptions([
          {
            value: "gallery",
            label: "Gallery only",
            disabled: currentPlan?.sub_tier === 2,
          },
          { value: "account", label: "Account-wide" },
        ]);
        setApplyScope(currentPlan?.sub_tier === 2 ? "account" : "gallery");
      }

      setShowPermissionDialog(true);
      return;
    }
    //ProSuite
    if (currentPlan?.sub_tier === 3) {
      if (isWheelBusinessBox) {
        setDialogOptions([
          {
            value: "wheel",
            label:
              "This Wheel Only – Saves the Business Box only for this Wheel",
          },
          {
            value: "gallery",
            label:
              "Gallery – Applies this Business Box to this wheel and the Gallery Page",
          },
          {
            value: "account",
            label:
              "Account-wide – Replaces the Business Box on the Gallery Page and every existing wheel on your account",
          },
        ]);
        setApplyScope("wheel"); // Set default selection for wheel context
      }

      setShowPermissionDialog(true);
      return;
    }

    //Premium
    handlePermissionApply("account", values);
  };

  const onSubmitHandler = async (values, formikHelpers) => {
    if (selectedBBox) {
      formikHelpers.setSubmitting(true);
      setApiLoading(true);
      updateBusinessBox.mutate(values, {
        onSuccess: (res) => {
          if (currBbox?.id === res.data.id) {
            if (isWheelBusinessBox) {
              dispatch(setBusinessBoxWheel(values));
              dispatch(pushToHistoryAction());
            } else {
              dispatch(updateProfileBusinessBox({ updates: values }));
              dispatch(editUserProfileAction({ business_box: values }));
            }
          }

          setApiLoading(false);
          onClose(true);
        },
        onError: (err) => {
          setApiLoading(false);
          toast("Error updating business box", { type: "error" });
          console.log(err);
        },
      });
    } else {
      setPendingFormValues(values);
      pendingFormValuesRef.current = values;
      setPendingFormikHelpers(formikHelpers);

      handleBusinessBoxPermissions({ values });
    }
  };

  const applyBusinessBoxOnProfile = (id, scope = null, showToast = true) => {
    setApiLoading(true);
    setPrimaryBusinessBox.mutate(
      {
        id: id,
        is_visible: scope === "account" ? true : false,
        is_base: scope === "account" ? true : false,
      },
      {
        onSuccess: (response) => {
          // First check if either value exists before dispatching
          const boxData = selectedBBox?.id
            ? selectedBBox
            : pendingFormValuesRef.current || pendingFormValues;

          if (boxData) {
            dispatch(
              updateProfileBusinessBox({
                updates: boxData,
              })
            );
            dispatch(
              editUserProfileAction({
                business_box: boxData,
              })
            );
          }

          setApiLoading(false);
          if (showToast) {
            toast("Primary Box updated successfully", { type: "success" });
          }
          onClose(true);
        },
        onError: (err) => {
          console.error(err);
          setApiLoading(false);
          toast("Error updating primary box", { type: "error" });
        },
      }
    );
  };

  const applyBusinessBox = (id, scope, showToast = true) => {
    if (isWheelBusinessBox) {
      dispatch(
        setBusinessBoxWheel(
          selectedBBox?.id
            ? selectedBBox
            : pendingFormValuesRef.current || pendingFormValues
        )
      );
      dispatch(pushToHistoryAction());
      toast("Business Box selected successfully", { type: "success" });
      onClose(true);
    } else {
      applyBusinessBoxOnProfile(id, scope, showToast);
    }
  };

  const handlePermissionApply = (scope = null, values = null) => {
    setApiLoading(true);

    //if its from manager select
    if (selectedBBox?.id) {
      if (isWheelBusinessBox) {
        // Handle different scopes for wheel business box
        applyBusinessBox();
        if (scope === "gallery") {
          applyBusinessBoxOnProfile(selectedBBox?.id, null, true); // Show toast for "Select" action
        } else if (scope === "account") {
          applyBusinessBoxOnProfile(selectedBBox?.id, scope, true); // Show toast for "Select" action
        }
        setApiLoading(false);
      } else {
        applyBusinessBox(selectedBBox?.id, scope, true); // Show toast for "Select" action
      }

      setShowPermissionDialog(false);
    } else {
      if (values || pendingFormValues) {
        console.log("pendingFormValues", values, pendingFormValues);

        createBusinessBox.mutate(values ? values : pendingFormValues, {
          onSuccess: (response) => {
            pendingFormikHelpers && pendingFormikHelpers.setSubmitting(false);
            pendingChangesSetter(false);

            if (isWheelBusinessBox) {
              // Handle different scopes for wheel business box
              applyBusinessBox();
              if (scope === "gallery") {
                applyBusinessBoxOnProfile(response.data.id, null, false); // No toast for "Save" action
              } else if (scope === "account") {
                applyBusinessBoxOnProfile(response.data.id, scope, false); // No toast for "Save" action
              }
              setApiLoading(false);
            } else {
              // Original gallery business box logic
              applyBusinessBox(response.data.id, scope, false); // No toast for "Save" action
            }

            setShowPermissionDialog(false);
          },
          onError: (err) => {
            setApiLoading(false);
            pendingFormikHelpers.setSubmitting(false);
            toast.error("Some error occurred!");
            console.error("bb not created:", err);
          },
        });
      }
    }
  };

  const handlePremiumDialog = () => {
    dispatch(
      openDialogPopup({
        isOpen: true,
        title: "Upgrade to Premium",
        text: "Upgrade to Premium to attach files or paste from clipboard.",
        primaryButtonTitle: "Upgrade today!",
        secondaryButtonTitle: "Cancel",
        secondaryButtonOnClick: () => dispatch(closeDialogPopup()),
        primaryButtonOnClick: () => {
          dispatch(closeDialogPopup());
          dispatch(
            openUpgradePopup({
              requiredSubscription: 3,
            })
          );
        },
      })
    );
  };

  return (
    <>
      <Formik
        initialValues={initialValues || businessBoxv2InitialValues}
        onSubmit={onSubmitHandler}
        enableReinitialize
        validateOnMount
        validationSchema={businessBoxv2ValidationSchema}
      >
        {({ values, submitCount, submitForm, touched, errors }) => (
          <Form>
            <FormStateWatcher />
            {pendingChanges && (
              <SaveChangesModal
                isOpen={svChOpen}
                title={"Save changes?"}
                subtitle={
                  "You have unsaved changes. Do you want to save them before closing ?"
                }
                onClose={() => {
                  svChOpenSetter(false);
                }}
                onSave={() => {
                  submitForm();
                  pendingChangesSetter(false);
                  onClose(true);
                }}
                onLeave={() => {
                  pendingChangesSetter(false);
                  onClose(true);
                }}
              />
            )}

            <Grid
              container
              sx={{
                pr: "5px",
                height: "86vh",
                pl: hideTabs && "30px",
              }}
            >
              <Grid
                xs={7}
                item
                style={{
                  //borderLeft: "1px solid #E1E1E1",
                  height: "calc(100% - 100px)",
                }}
                sx={{
                  overflowY: "auto !important",
                  flexShrink: 0,
                }}
              >
                <InnerForm
                  bBox={selectedBBox}
                  bBoxSetter={setSelectedBBox}
                  onClose={() => {
                    onClose(true);
                  }}
                  apiLoading={apiLoading}
                  apiLoadingSetter={setApiLoading}
                  isWheelBusinessBox={isWheelBusinessBox}
                  currentBBox={currBbox}
                  openLibrarySection={openLibrarySection} // Pass this prop
                  handleBusinessBoxPermissions={handleBusinessBoxPermissions}
                />
              </Grid>

              {/* Preview section - revised for proper scrolling */}
              <Grid
                item
                xs={5}
                sx={{
                  position: "relative", // Add position relative
                  height: "calc(100% - 130px)", // Match parent height
                  px: "10px",
                  display: "flex",
                  flexDirection: "column", // Use flexbox for layout
                }}
              >
                {/* Fixed header section */}
                <Box
                  sx={{
                    display: "flex",
                    paddingBottom: "1.1rem",
                    borderBottom: "1px solid #E1E1E1",
                    alignItems: "center",
                    position: "sticky", // Make header sticky
                    top: 0,
                    backgroundColor: "#ffffff",
                    zIndex: 2,
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#0F0F0F",
                      fontSize: "24px",
                      fontWeight: "700",
                      lineHeight: "20px",
                      fontFamily: "DM Sans",
                    }}
                  >
                    Preview
                  </Typography>
                  <Tooltip
                    sx={{
                      color: "#797879",
                      fontSize: "16px",
                      fontWeight: "700",
                      lineHeight: "24px",
                      fontFamily: "DM Sans",
                    }}
                    title={`This is how your business box will appear to people
                viewing your ${isWheelBusinessBox ? "wheel" : "gallery"}`}
                  >
                    <IconButton>
                      <InfoOutlined />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Scrollable content container */}
                <Box
                  sx={{
                    mt: "20px",
                    overflowY: "auto",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* Updated DataBox wrapper to prevent inner scrolling */}
                  <Box
                    sx={{
                      maxWidth: "350px", // Match the width in ViewOne component
                      width: "100%",
                    }}
                  >
                    <BboxDataBox selectedBBoxData={selectedBBox} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      <BusinessBoxPermissionDialog
        isOpen={showPermissionDialog}
        onClose={() => {
          setShowPermissionDialog(false);
        }}
        onApply={handlePermissionApply}
        icon={!showBBPremiumDialogAlways && ProSuite}
        apiLoading={apiLoading}
        options={dialogOptions}
        defaultValue={applyScope}
        handleDisableIconClick={handlePremiumDialog}
      />
    </>
  );
};

export default BusinessBoxForm;
